import React from 'react'
import { Container, MedImgWrapper, OuterPaddingTheme } from '@styles/global/helpers'
import { IBonusItem, IBonusSection } from '@et/types/Courses'
import styled from 'styled-components'
import { FlexTabletRow } from '@styles/global/flexGrid'
import { device } from '@styles/global/breakpoints'
import ImgSmall from '@components/imageModules/v2/imgSmall'
import { IGatsbyChildImageSharp, IGatsbyImageDataObject } from '@et/types/Gatsby'
import GatsbyImgSmall from '@components/imageModules/v3/gatsbyImgSmall'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GATSBYIMGLOADING } from '@et/types/Enums'
import IPadImgv4Small from '@components/imageModules/v4/iPadImgv4_small'

export interface IBonusImages {
  gatsbySource: IGatsbyImageDataObject,
  alt: string | undefined
}

interface IProps {
  bonusSection: IBonusSection,
  headerImg: {
    gatsbySource: IGatsbyImageDataObject,
    alt: string
  }
  iPadSmall: IGatsbyImageDataObject,
  bonusImages: IBonusImages[]
}

function BonusLayoutAv4({ bonusSection, headerImg, iPadSmall, bonusImages }: IProps) {

  return (
    <OuterPaddingTheme altBg={true}>
      <Container>
        <MedImgWrapper>
          <GatsbyImage alt={headerImg.alt} image={headerImg.gatsbySource.gatsbyImageData} loading={GATSBYIMGLOADING.LAZY} />
        </MedImgWrapper>
      </Container>

      <BonusContainer altBg={true}>
        <Container>
          <BonusItems gridType={bonusSection.gridType}>
            {bonusSection.items.map((bonus: IBonusItem, index: number) => {
              const bonusImage = bonusImages[index]

              return (
                <BonusItem key={bonus.title}>
                  <MedImgWrapper>
                    {bonusImage && iPadSmall &&
                      <IPadImgv4Small
                        img={bonusImage.gatsbySource} iPadImg={iPadSmall} alt={bonusImage.alt ? bonusImage.alt : 'Every Tuesday Bonus!'} />}
                  </MedImgWrapper>
                  <h2>{bonus.title}</h2>
                  <p>{bonus.desc}</p>
                </BonusItem>
              )
            })}
          </BonusItems>
        </Container>
      </BonusContainer>
    </OuterPaddingTheme>
  )
}

interface IBonusListItem {
  gridType: number
}

const BonusContainer = styled(OuterPaddingTheme)`
  padding-bottom: 0;
  
  @media ${device.tablet}{
    padding-bottom: 0;
  }

`
const BonusItems = styled(FlexTabletRow) <IBonusListItem>`
  margin: 0 auto;
  ${props => setFlexGridType(props.gridType)};
`

const BonusItem = styled.div`
  padding: 0 20px 30px;
  max-width: 500px;
  margin: 0 auto;
 
  h2{
    line-height: 26px;
    color: ${props => props.theme.headlineColor};
    margin: 20px 0;
  }
  p{
    color: ${props => props.theme.textColor};
    line-height: 28px;
  }
  img{
    margin: 0 auto;
  }
  
  @media ${device.tablet}{
    max-width: none;
    margin: 0;
    p{
      text-align: left;
    }
  }

`

function setFlexGridType(type: number) {
  switch (type) {
    case 2:
      return `
        max-width: 900px;
        ${BonusItem}{
          text-align: center;
          flex: 0 1 50%;
          max-width: 450px;
        }

        ${MedImgWrapper}{
          max-width: 380px;
        }
      `
    case 3:
      return `
      ${BonusItem}{
        @media ${device.tablet}{
          flex: 0 1 50%;
        }
        @media ${device.laptop}{
          flex: 0 1 33.333333%;
        }
        
      }
      `
    default:
      return `
        ${BonusItem}{
          flex: 1;
        }
      `
  }
}

export default BonusLayoutAv4
